const carouselItems = [
  {
    title: '暗网入门完全指南：从零到安全访问',
    desc: '本专题系统讲解暗网基础概念、Tor浏览器安装配置、VPN搭配方案与安全环境搭建，是暗网新手的最佳起点。覆盖Windows、macOS、Linux及Android全平台教程，手把手带你安全进入暗网世界。',
    img: 'https://readdy.ai/api/search-image?query=Complete%20beginner%20guide%20to%20dark%20web%20concept%20with%20stepping%20stones%20path%20into%20digital%20depth%2C%20dark%20background%20with%20warm%20amber%20illuminated%20pathway%2C%20minimalist%20journey%20visual%20metaphor%2C%20progressive%20discovery%20aesthetic%2C%20clean%20atmospheric%20composition%20with%20guiding%20light%2C%20no%20text&width=900&height=400&seq=carousel-entry-guide&orientation=landscape',
    tag: '入门必读',
    tagColor: 'primary',
  },
  {
    title: 'Tor浏览器深度评测：为什么它是暗网访问的首选',
    desc: '对Tor浏览器进行全面技术评测，详解洋葱路由工作原理、浏览器隐私设置优化、常见问题排查方法以及与I2P、Freenet等替代工具的横向对比分析。',
    img: 'https://readdy.ai/api/search-image?query=Tor%20browser%20deep%20review%20concept%20with%20onion%20layers%20and%20privacy%20shield%2C%20dark%20charcoal%20background%20with%20warm%20amber%20and%20copper%20accents%2C%20browser%20security%20visual%20metaphor%2C%20minimalist%20tech%20review%20aesthetic%2C%20networking%20layers%20visualization%2C%20clean%20composition%2C%20no%20text&width=900&height=400&seq=carousel-tor-review&orientation=landscape',
    tag: '深度评测',
    tagColor: 'secondary',
  },
  {
    title: '暗网安全访问全攻略：保护你在暗网中的每一步',
    desc: '覆盖暗网安全访问的全部环节：系统加固、VPN选择指南、PGP加密使用教程、钓鱼网站识别技巧、加密货币安全交易规范以及隐私泄露应急处理方案。',
    img: 'https://readdy.ai/api/search-image?query=Complete%20security%20protection%20guide%20concept%20with%20shield%20and%20lock%20patterns%20surrounding%20digital%20core%2C%20dark%20background%20with%20warm%20amber%20protection%20rings%2C%20cybersecurity%20fortress%20visual%20metaphor%2C%20minimalist%20defense%20layers%20aesthetic%2C%20clean%20atmospheric%20composition%2C%20no%20text&width=900&height=400&seq=carousel-security-guide&orientation=landscape',
    tag: '安全必读',
    tagColor: 'accent',
  },
  {
    title: '2026年暗网网址大全：最新可用洋葱站点导航',
    desc: '收录并验证2026年最新可用的暗网.onion网址，分类整理包括搜索引擎、新闻资讯、技术论坛、学术资源等类别，每周更新确保链接有效性。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20web%20URL%20directory%20concept%20with%20interconnected%20onion%20nodes%20forming%20navigation%20map%2C%20dark%20background%20with%20warm%20copper%20web%20connections%2C%20hidden%20network%20visualization%2C%20minimalist%20directory%20aesthetic%2C%20organized%20node%20structure%2C%20clean%20composition%2C%20no%20text&width=900&height=400&seq=carousel-url-list&orientation=landscape',
    tag: '网址导航',
    tagColor: 'primary',
  },
  {
    title: '最新吃瓜爆料汇总：暗网社区热点事件全追踪',
    desc: '聚合近期暗网社区最具话题性的吃瓜爆料内容，涵盖数据泄露追踪、知名站点动态、匿名投稿精选以及安全事件通报，一站掌握暗网世界的风吹草动。',
    img: 'https://readdy.ai/api/search-image?query=Breaking%20news%20and%20leaks%20aggregation%20concept%20with%20pulsating%20information%20waves%2C%20dark%20background%20with%20crimson%20and%20amber%20hot%20topic%20highlights%2C%20whistleblower%20and%20news%20aesthetic%2C%20minimalist%20information%20flow%20visualization%2C%20dynamic%20yet%20clean%20composition%2C%20no%20text&width=900&height=400&seq=carousel-gossip-news&orientation=landscape',
    tag: '吃瓜合集',
    tagColor: 'accent',
  },
  {
    title: '匿名投稿实战经验：如何安全分享你的暗网见闻',
    desc: '从PGP密钥生成到稿件加密上传，手把手教你如何安全地进行匿名投稿。包含投稿内容建议、安全注意事项、常见问题解答以及投稿人权益保护说明。',
    img: 'https://readdy.ai/api/search-image?query=Anonymous%20submission%20guide%20concept%20with%20encrypted%20envelope%20and%20digital%20secrecy%20patterns%2C%20dark%20background%20with%20crimson%20and%20warm%20amber%20accents%2C%20privacy%20first%20visual%20metaphor%2C%20minimalist%20guide%20aesthetic%2C%20secure%20communication%20theme%2C%20clean%20composition%2C%20no%20text&width=900&height=400&seq=carousel-anonymous-tips&orientation=landscape',
    tag: '投稿指南',
    tagColor: 'secondary',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          六大精选专题，深入探索暗网世界的方方面面
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all duration-200 flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[220px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded text-[10px] font-medium ${
                  item.tagColor === 'primary'
                    ? 'bg-primary-500/80 text-background-950'
                    : item.tagColor === 'accent'
                    ? 'bg-accent-500/80 text-background-50'
                    : 'bg-secondary-500/80 text-background-50'
                }`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}